// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IClientPolicyDefaults } from 'src/types/d3ePolicy';
import { API_URL } from 'src/shared/api';
import {  catchError } from 'rxjs/operators';
import {ConfigurationService} from './configuration-service';

@Injectable({
  providedIn: 'root'
})
export class ClientPolicyService {

  constructor(
      private http: HttpClient,
      private configurationService: ConfigurationService,
  ) { }

  getClientPolicyDefaults(selectedOrgId = ''): Observable<IClientPolicyDefaults> {
    let url = `${this.configurationService.apiUrl}${API_URL.DEFAULT_POLICY}`;

    if ( selectedOrgId.length > 0 ) {
      url += '?selectedOrgId=' + selectedOrgId;
    }

    return this.http.get<IClientPolicyDefaults>(url)
    .pipe(
      catchError(this.handleError.bind(this))
    );
  }

  handleError(errResponse: HttpErrorResponse | any): any {
    return throwError(errResponse.error || 'Server error');
  }
}
